<template>
    <div style='width: 100%'>
        <el-table :data="tableData" >
            <el-table-column prop="time" label="時間" align='center' width="140px"></el-table-column>
            <el-table-column prop="ver" label="バージョン" align='center' width="120px"></el-table-column>
            <el-table-column width="540px">
                <template slot="header" slot-scope="scope">
                    <el-input v-model="search"  size="mini" placeholder="検索キーワードを入力してください" clearable @clear="getTableData" @keyup.enter.native="getTableData">
                      <el-button slot="append" icon="el-icon-search" @click="getTableData"></el-button>
                    </el-input>
                </template>
                <template slot-scope="props">
                    <p v-for="(item,index) in props.row.update" :key="index">
                        {{index+1 + ". " + item}}
                    </p>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[5, 10, 15, 25]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
      </el-pagination>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
      tableWidth: '',
      pagination: {
        total: 0,
        pageSize: 5,
        currentPage: 1
      },
      search: '',
      tableData: [],
      releaseData: [
        {
          time: '2023年8月20日',
          ver: 'V6.1.1.2-従来UI版',
          update: [
            'インデックス作成処理モジュールのバージョンアップにより、作成時間の短縮ができました'
          ]
        },
        {
          time: '2022年10月12日',
          ver: 'V6.1.1.1-WebUI版',
          update: [
            'ページ番号の表示を作り直しました',
            '左側のレイアウトを変更、ページネーションを上部に配置しました',
            '左側のレイアウトを変更、ボタン欄をなくして、ファイルの傍に配置しました',
            '右側のテキスト表示欄に右クリックするとポップアップメニューを表示します'
          ]
        },
        {
          time: '2022年7月11日',
          ver: 'V6.1.1.0',
          update: [
            '標準版もPro版も前方一致検索とキーワード検索併用可能。例えば「Search*　画面」で検索可能',
            'Pro版、WebUI版、標準版に色テーマの設定が可能（インデックスメニューのオプション設定サブメニュー→画面設定タブでカラーテーマは白、黒の切り替えが可能）',
            'WebUI版に対して、検索履歴をプルダウンリストから表示するように変更',
            'WebUI版に対して、ファイル名と概要内容を一コラムに表示する'
          ]
        },
        {
          time: '2022年3月11日',
          ver: 'V6.1.0.9',
          update: [
            '標準版もPro版も前方一致検索ができた。検索語に*をつけて例えば300*で検索可能',
            'Pro版に色テーマの設定が可能（インデックスメニューのオプション設定サブメニュー→画面設定タブでカラーテーマは白、黒の切り替えが可能）',
            'Pro版の反転処理も改善した'
          ]
        },
        {
          time: '2022年1月26日',
          ver: 'V6.1.0.8',
          update: [
            '最新ウェブ技術を使ったPro版のUIを作り直した。そのため、Pro版のご利用はWindows7以上64ビットOSだけになります'
          ]
        },
        {
          time: '2021年4月2日',
          ver: 'V6.1.0.7',
          update: [
            'インデックス更新処理をWindowsサービスとして登録し、ログインしなくても、インデックス更新できます。この機能は社内検索システム構築時にエージェント側だけ利用できます。'
          ]
        },
        {
          time: '2020年12月24日',
          ver: 'V6.1.0.6',
          update: [
            '各ダイアログを再作成して、ディスプレーフォントのサイズに対応できました。',
            '標準版のWindows XPの場合、オプション画面が表示できない問題を解消しました。',
            '一部検索語の近傍検索で「ヒットしても反転しない」障害の対応。',
            '新HPのリリース'
          ]
        },
        {
          time: '2020年6月10日',
          ver: 'V6.1.0.5',
          update: [
            'インデックス作成速度の向上ー利用可能メモリに応じてインデックス作成処理の最適化',
            '標準版についてメモリツールに利用可能な最大値チェックを入れた',
            'MAC　OS上の改行コード（"\r"）を対応した'
          ]
        },
        {
          time: '2020年4月26日',
          ver: 'V6.1.0.4',
          update: [
            '「テキスト」、「抜粋」、「該当行」ビューどれかを選択したら、その状態を保ちます、ファイルをクリックすると、選択されたビューで表示するように実装した',
            '右側のビューで単語を選択して「検索し直す」機能を実装した',
            'ネットワークドライブの割りあて機能を実装した',
            'インデックス作成、検索時プログレスバーを表示するようにした',
            '障害対応: ツールバーにある絞込むボタンを押すと検索対象に対して絞り込むが可能'
          ]
        },
        {
          time: '2020年3月19日',
          ver: 'V6.1.0.3',
          update: [
            '検索結果からさらに絞込む機能の実装'
          ]
        },
        {
          time: '2019年12月1日',
          ver: 'V6.1.0.2',
          update: [
            'プレビュー機能の改善、スピードの向上',
            '拡張子とともに「検索対象外」にファイルの指定も可能',
            '「再作成」チェックが入ったインデックスグループだけを「インデックス再作成」対象にする。（退避されたインデックスグループを再作成の対象外にする）',
            '設定ファイル（Config.xml）にSynonymを追加、1の場合は類似語検索機能が有効にする、0の場合は類似語検索機能が無効にする。<Synonym>0</Synonym>'
          ]
        },
        {
          time: '2019年10月10日',
          ver: 'V6.1.0.1',
          update: [
            'インデックスデータ量を減らすため、データ構造の変更',
            '検索と反転の表示速度を向上させる'
          ]
        },
        {
          time: '2019年6月3日',
          ver: 'V6.1.0.0',
          update: [
            '大きいファイルの表示について性能改善',
            'PSTファイルのインデックスデータ作成に作った一時ファイルの削除',
            'メイン画面のインデックス名にフォルダー情報の表示',
            'UIの改善',
            'MacOS版の更新（7月28日）'
          ]
        },
        {
          time: '2019年1月8日',
          ver: 'V6.0.0.1',
          update: [
            '新しいUI：新しいデザインアイコンなど',
            '色の管理：テキスト色、バックグランド色、反転色の設定は可能',
            'Java バージョンの更新',
            'プレビュー機能のバグ修正',
            'テーブルヘーダの表示・非表示',
            'ユーザ辞書のサポート(標準版もPro版も)'
          ]
        },
        {
          time: '2018年11月9日',
          ver: 'V6.0.0.0',
          update: [
            'MAC OSバージョンのリリース',
            '複合語をサポートする近傍検索',
            'ユーザ辞書のサポート',
            'ホットキーでメイン画面を呼ぶ機能のバグ修正:誤動作の防止',
            'コピー・移動・削除処理バグの修正',
            '面画面の上部レイアウトの調整:一部のOSで検索テキストボックスが隠さないようにポジションを調整した'
          ]
        },
        {
          time: '2018年8月12日',
          ver: 'V5.0.0.1',
          update: [
            '類似語の検索ができました。この機能のご利用には、インターネットへ接続が必要、この機能を無効にするには、設定ファイルConfig.xmlに下記一行を追加すれば結構です<Synonym>70</Synonym>'
          ]
        },
        {
          time: '2018年7月20日',
          ver: 'V5.0.0.0',
          update: [
            '右クリックメニューで「テキスト」ビュー、「抜粋」ビュー、「該当行」ビューへお互いに遷移できるようにしました',
            '右クリックメニューで「テキスト」ビュー、「抜粋」ビュー、「該当行」ビューへお互いに遷移する時、カレント行をマークできるようにしました',
            'マシンの解像度をチェックして、タブレットであれば、UIを自動調整できるようにしました',
            'メールファイル（MSGファイル、EMLファイル）の場合、ファイル日付ではなくメール送信日付が表示され、絞り込み検索できるようにしました'
          ]
        },
        {
          time: '2018年2月16日',
          ver: 'V4.0.0.10',
          update: [
            'PSTファイルの検索が可能',
            'オプション画面で、対象ファイルタイプ、排除対象ファイルタイプをダイアログで選択して設定できるようにしました'
          ]
        },
        {
          time: '2017年10月25日',
          ver: 'V4.0.0.9',
          update: [
            'ファイルプレビュー機能の実現',
            'プレビューウィンドウで右マウスで「縮小」、「拡大」、次のページ、前のページを実装',
            '利用メモリ設定ツールの障害対応'
          ]
        },
        {
          time: '2017年9月1日',
          ver: 'V4.0.0.8',
          update: [
            'ファイル共有機能の実現',
            'HTTPサーバーの実現',
            'ウェブ検索機能を付けました。一つボタンで、Bing・Google・Wiki・Yahooで入力したキーワードで検索できます'
          ]
        },
        {
          time: '2017年5月30日',
          ver: 'V4.0.0.7',
          update: [
            '最近使用したファイルリストをダブルクリックすると、メイン画面に遷移します',
            '最近使用したファイルリストをクリアできるようにしました',
            '上下の矢印キーで検索ワード履歴を選択すると、テキストボックスの内容を更新させる',
            '検索キーワード履歴をクリアできる'
          ]
        },
        {
          time: '2017年4月11日',
          ver: 'V4.0.0.6',
          update: [
            '絞り込み条件は一旦設定したら、クリアボタンが押されるまで保持します、それからの検索に、この条件を適用するように実装追加',
            '最近使用したファイルリスト一覧を実装した',
            '高い解像度に対応するオプションを追加した'
          ]
        },
        {
          time: '2017年3月16日',
          ver: 'V4.0.0.5',
          update: [
            'プレビューの速度を改善',
            'ファイル名検索の速度を改善',
            'インデックス作成の速度を改善'
          ]
        },
        {
          time: '2017年2月17日',
          ver: 'V4.0.0.3',
          update: [
            'ファイル名検索のインクリメント検索を実装した',
            'ファイル名検索の結果をアンダーラインで表示する',
            'アンインストールする際、認証を自動解除するように実装した'
          ]
        },
        {
          time: '2016年11月30日',
          ver: 'V4.0.0.2',
          update: [
            '個別インデックスを指定して再作成する',
            'インデックスデータ保存場所が外付けHDの場合、差し抜けによってドライブが変わっても、検知できて、自動的にインデックスデータフォルダを設定し直すこと',
            'フォルダー指定して絞り込む検索機能',
            'ホットキーを押すと、前回の検索結果をクリアする'
          ]
        },
        {
          time: '2016年11月9日',
          ver: 'V4.0.0.1',
          update: [
            'インデックスの退避・復活機能',
            'ステータスバーに検索時間を表示する'
          ]
        },
        {
          time: '2016年10月1日',
          ver: 'V4.0.0.0',
          update: [
            '検索結果リストにページをつける、ページサイズの設定、ページ遷移する機能を実装した、これにより、検索結果リストの表示行数は何万までも可能',
            '検索結果リストの高さを動的に調整できるように実装した',
            'ファイル名の全文検索を実装した',
            'ツールバーボタンの状態を表示するようにした',
            '参考資料の追加：社内検索システム構築図 http://www.searchplusplus.jp/Agent_Client.pdf'
          ]
        },
        {
          time: '2016年8月10日',
          ver: 'V3.2.2.6',
          update: [
            '検索機能の改善： いままでの変化形を一緒に検索するモードに入力語とぴったり一致する検索モードも実現しました。デフォルトはぴったり一致するモードにした。変化形を一緒に検索するモードへ切り替えるにはConfig.xmlに下記一行を追加する<Lem>0</Lem>',
            '複数検索語の場合、演算方法をANDかORかに指定できる',
            '複数インデックス設定画面に追加、削除、リセットアイコンを追加した',
            'インデックスデータフォルダー及びソフトウェアのインストールフォルダへの書き込み権限あるかどうかをチェックするように実装した',
            '「ユーザへのお知らせ」ダイアログをカスタマイズした（最新版はベクター社にリリース依頼中ですが、このサイトからダウンロードできます）'
          ]
        },
        {
          time: '2016年6月18日',
          ver: 'V3.2.2.5',
          update: [
            '一太郎IFILTERのフォントメッセージ問題を解決ため、FILTERを利用せず一太郎ファイル(.jtd)の解析を実現'
          ]
        },
        {
          time: '2016年3月25日',
          ver: 'V3.2.2.4',
          update: [
            'UIの改善:ビューモード状態の表示',
            '認証機能の改善：プロキシサーバーを設定できるようにした',
            'ステータスバーで、インデックスデータ作成時の進捗表示位置の調整',
            '異常終了の時、設定ファイルの自動バックアップと自動リストア'
          ]
        },
        {
          time: '2016年2月15日',
          ver: 'V3.2.2.3',
          update: [
            '検索結果リストアイコンなど表示調整',
            'インストール･アンインストールプログラム機能増強',
            'インデックス作成時、進捗（％）をステータスバーで表示する',
            '一つインスタンスの機能実装：Searchplusplus.exeを二回起動させると、一回目時の画面を表示する',
            'バグ修正:',
            '        ：排除フォルダの設定',
            '        ：インデックスを自動更新後の検索'
          ]
        },
        {
          time: '2016年1月15日',
          ver: 'V3.2.2.2',
          update: [
            'OSからDrag&Dropで検索対象フォルダー設定できるようにした　',
            'ネットワーク認証・解除機能の実現',
            'お知らせ機能の実装'
          ]
        },
        {
          time: '2015年10月23日',
          ver: 'V3.2.2',
          update: [
            '反転処理をより判りやすくした',
            '各ビューでキーワードを反転表示できるようにした',
            '英語の単数・複数検索できるようにした',
            '日本語の動詞活用形検索できるようにした',
            '「前のキーワード」ボタンを実装した',
            '障害対応'
          ]
        },
        {
          time: '2015年9月26日',
          ver: 'V3.2.1',
          update: [
            '複数インデックスデータの作成が可能',
            'インデックス作成時、大きいファイルに対してめもり足りない場合、下記メッセージが出ますが、１０秒以上経つと自動的にスキップして処理が続きます',
            '非常駐モードで検索する時のメッセージに「今後表示しない」オプションを付けます'
          ]
        },
        {
          time: '2015年6月21日',
          ver: 'V3.1.1',
          update: [
            '検索ワード履歴を保持できた',
            '画面のポジションを保持できた',
            'マウスを振ってメイン画面を表示できるようになった',
            'タブレート版を作成できた',
            'インストール版を作成できた'
          ]
        },
        {
          time: '2015年3月22日',
          ver: 'V3.1',
          update: [
            'インデックス更新：一定のアイドル時間が続くと更新します',
            '非常駐モードの増強：インデックス更新機能を実現、「即更新」ボタンを押せば、インデックス更新できるようにしました',
            'インデックスデータが更新したら、検索リストを自動的に更新します'
          ]
        },
        {
          time: '2015年1月12日',
          ver: 'V3.0',
          update: [
            'ホットキーなしに設定可能になります',
            'ホットキーで画面を呼び出す時、前回の検索キーワードを全選択にする',
            'アプリケーション終了時、メイン画面及び左右のビューのサイズを覚え、次回開く時、元のサイズに戻る。(例:左右のビューの比率を調整して、メイン画面の「その他機能」ー>「終了」ボタンを押すと、設定は保存されます)',
            '外部プログラムでファイル開く時、検索すると検索しない両方も可能にする',
            '指定時刻でインデックス更新の設定に、自動シャットダウンオプションをつける可能、夜間インデックス作成したら、自動シャットダウンできる',
            'オプション設定ダイアログにユーザ登録ボタンを追加した'
          ]
        },
        {
          time: '2014年9月28日',
          ver: 'V2.8.9.2',
          update: [
            'GUI更改:テーブレットも正しく表示できるようにGUIの表現を更改'
          ]
        },
        {
          time: '2014年9月7日',
          ver: 'V2.8.9.1',
          update: [
            '障害対応：現象：パスワードをかけるPDFファイルが存在する場合、インデックスデータ作成処理は途中で中止してしまった。対応：PDF解析にエラー発生したら、該当ファイルをスキップして、処理を続けるようにした'
          ]
        },
        {
          time: '2014年8月29日',
          ver: 'V2.8.9',
          update: [
            'GUI更改:ファイルの表示アイコンを新しいデザインにした',
            'PDFファイルに対して、ページ情報を解析できるようにした.検索結果のPDFファイルに対して、右クリックして、PDFのページへ飛ぶ機能を実現した'
          ]
        },
        {
          time: '2014年7月25日',
          ver: 'V2.8.8',
          update: [
            'GUI更改:ソート機能・絞り検索機能及び各種検索結果のビュー機能をアイコン化して、ワンクリックしてアクセス',
            'インデックスデータの自動更新設定:「オプション」－>その他」タブに指定した時間・指定した間隔 或は手動でインデックスデータを自動更新'
          ]
        },
        {
          time: '2014年6月20日',
          ver: 'V2.8.7',
          update: [
            'テキスト表示領域に文字の折り返し表示及びフォント変更が実装した',
            'ファイルのコピー・移動・削除が可能: 複数ファイルを選択する場合、CtrlまたはShiftキー押してファイルをクリックして、画面上のコピー・移動ボタンを押せば、ファイルのコピー先・移動先を指定できます。Ctrl+Aの場合、すべてのファイルは操作対象になる.コピー先に同名ファイルすでに存在している場合、上書きかどうかの選択可能',
            'システムトレー領域の複数アイコンの障害が修正',
            '「購入サイトへ」ボタンを追加'
          ]
        },
        {
          time: '2014年5月3日',
          ver: 'V2.8.6',
          update: [
            '一太郎ソフトウェアと連動する。一太郎がインストールしてあるPCに対して、IFILTERで検索できないファイルに、一太郎を起動させて、データをインデックス化して検索できるようにする'
          ]
        },
        {
          time: '2014年4月12日',
          ver: 'V2.8.5',
          update: [
            '近傍検索（近接検索）機能の実現。[キーワードA　W5 キーワードB] =>「A、Bの間５単語以内」の状態を検索する',
            'PDF Xchange Viewerと連動できて、検索用語を渡して、用語位置リストが表示できるようにした',
            'SJIS,Unicodeなど各種フォーマットのテキストを支持する'
          ]
        },
        {
          time: '2014年2月6日',
          ver: 'V2.8.4',
          update: [
            'ご利用環境に対して、IFILTERのインストール状態を検知する機能を追加した',
            'インデックス作成時及び検索時、メイン画面にGIF動画で「処理中」を表すようにしました',
            'アンインストールツールを実行させると、実行中の全文検索くんを検知し、停止させてから、フォルダーにあるすべてのファイルを削除するようにした',
            '第三社のIFILTERによる処理エラーを検知して、継続処理できるようにした'
          ]
        },
        {
          time: '2013年12月14日',
          ver: 'V2.8.3',
          update: [
            '障害対応：ファイル名検索で日本語も検索可能にしました',
            'XPS　IFILTERサポートした。MICROSOFT社のIFILTERをダウンロードしてインストールすれば、XPSを検索可能になる。IFILTERサポートについて、詳細は本サイトのリンクページをご参照してください',
            'IFILTERのテキスト抽出プログラムが利用可能なメモリの増加、１０MB以上４０M（目安）のファイルも対応できるようにしました',
            '検索結果リスト項目の高さが手動で設定できるようにしました。設定ファイル（Config.xml）に下記パラメタの設定が可能になった。<TableHeight>70</TableHeight>TableHeightの値はピックセル単位です'
          ]
        },
        {
          time: '2013年11月10日',
          ver: 'V2.8.2',
          update: [
            '「オプション」画面に検索結果リスト表示順を設定できるようにした(この機能をご利用する場合、インデックスの再作成が必要)',
            'IFILTERサポートした。これにより、メーカーのIFILTERをダウンロードしてインストールすれば、一太郎、Xerox Document,縦書きPDFなどを検索可能になる。IFILTERサポートについて、詳細は本サイトのリンクページをご参照してください'
          ]
        },
        {
          time: '2013年9月16日',
          ver: 'V2.8',
          update: [
            '「オプション」画面を整理して、タブでグルーピング化した',
            '入力語の分析するかどうかオプションを追加',
            'フォルダーを整理して、実行プログラムをフォルダー外に出す',
            'プライベートＪＲＥを添付した 、外部ＪＡＶＡ環境に依存しないようにした'
          ]
        },
        {
          time: '2013年8月2日',
          ver: 'V2.7.2',
          update: [
            '「次のキーワードへ」ボタンを追加、つまり、該当ファイルの全テキスト内容を表示したら、キーワードのある場所にフォーカスを移すことを実装した',
            '多国言語をサポート機能を追加',
            'テキスト内容を選択したり、コピーしたりできるようにした',
            'オプション画面に処理対象ファイルの指定が可能になった。指定がない場合、全ファイルは処理対象にする'
          ]
        },
        {
          time: '2013年6月30日',
          ver: 'V2.7.1',
          update: [
            'Win7では一部の検索結果リスト表示の途切れに対して、表示幅を調整した',
            '検索結果となる文章内容にキーワードをハイライトさせるようにした',
            'キーワードの該当行前後内容を表示する機能（抜粋機能）の実現',
            '一旦中止になったインデックスデータ作成は中止したところから再開できるようにした.インデックス作成完了していないフォルダーに対してインデックスデータの自動更新はしません',
            '最大利用メモリを設定できるツールを提供した',
            'サイズの大きいファイルについてインデックス作成時メモリが足りなかったら、スキップするかメモリを追加するか処理できるようになった',
            'PDFの外部開くプログラムについてIEを経由しないようにした'
          ]
        },
        {
          time: '2013年5月11日',
          ver: 'V2.6',
          update: [
            '「ファイル名でソートする」機能の変更,検索結果に対して、ソート基準はフールパスではなく、ファイル名にした',
            '「検索結果表示」機能に「該当行の前後5行を含んで表示する」機能を追加,つまり、「該当内容の抜粋を表示する」機能を追加した',
            '該当行のハイライト機能、「該当内容の抜粋表示」機能、「テキスト内容の表示」機能に該当行をハイライトした',
            '時間かかる処理に対してスレッド化、「テキスト内容の表示」機能、「該当行まで検索」機能、「該当内容の抜粋を表示する」機能をスレッド化して、大きいなファイルの処理でも、プロセス状態を表示できで、フリーズ感がないことにした',
            'テキストボックス表示内容の切り替え、右側のテキストボックスにも右メニューを追加して、「テキスト内容の表示」と「該当内容の抜粋を表示する」を切り替えることができた',
            '障害対応：複数キーでの内容検索、V2.6版前の各バージョンでは、「該当行まで検索」機能に対して、AND・ORを利用して複数キー検索する場合、該当行を検出できるようになりました',
            'ログ出力：処理失敗したものに対してエラーログを出力、インデックス作成処理で失敗したファイルに対して、エラーを検知し、ログに出力する機能を追加しました',
            '「該当行まで検索」表示順を変更、V2.6版前の各バージョンでは、上記機能の結果表示にSimilarity（相似度）の点数順で表示してきたが、V2.6版から行番号順で表示する'
          ]
        },
        {
          time: '2013年4月6日',
          ver: 'V2.5',
          update: [
            'アンインストールツールを実装した（DeleteTool.exe)',
            '検索結果ソート（更新時間昇順、降順）を実現',
            '検索結果をテキストへ出力機能を追加',
            'ホットキー機能の増強',
            'インデックスデータ保存場所のデフォルト値を設定',
            'インデックスデータ作成機能の増強（サイズの大きいファイルへの対応）'
          ]
        },
        {
          time: '2013年2月16日',
          ver: 'V2.4',
          update: [
            '画面を見直した',
            '検索結果ソート（ファイル名順、更新時間順、ファイルタイプ順）、絞込み機能を追加（ファイルタイプ、更新時間）',
            '検索結果をテキストへ出力機能を追加',
            '複数キーワードのAND/OR/NOT検索を実現',
            'ファイル名検索機能を追加'
          ]
        },
        {
          time: '2013年1月6日',
          ver: 'V2.3',
          update: [
            '「外部プログラムで開く」機能を増強、ファイルを開くとともに検索をかけ、該当文字をハイライト表示',
            'インデックス作成機能を強化',
            '検索画面を表示させるホットキーはユーザ設定できるようにしました',
            '説明書を更新しました'
          ]
        },
        {
          time: '2012年12月25日',
          ver: 'V2.01D',
          update: [
            'インデックス作成時、処理しているファイル名をメッセージに表示する',
            '圧縮ファイルを処理対象から排除するように設定'
          ]
        },
        {
          time: '2012年12月12日',
          ver: 'V2.01',
          update: [
            'インデックスデータ作成機能を強化.複雑な算式、画像つきPDFを解析できるようにしました',
            'Ctrl+Shiftで検索画面を表示'
          ]
        },
        {
          time: '2012年11月25日',
          ver: 'V2.0',
          update: [
            '検索対象監視機能およびインデックス自動更新機能の実現',
            'トレーモードの実現',
            'インデックス作成機能の速度改善',
            '二回連続Ctrlキーで検索画面を表示'
          ]
        },
        {
          time: '2012年10月14日',
          ver: 'V1.3.2',
          update: [
            '検索対象から排除するファイルの設定ができるようにしました',
            '検索対象を選ぶための複数フォルダー選択ダイアログの表示速度が改善しました',
            '検索結果リストの各行の最初にファイル名を表示するようにしました',
            '最初目の起動で、表示言語を選択できるようにしました'
          ]
        },
        {
          time: '2012年8月25日',
          ver: 'V1.3',
          update: [
            '複数フォルダーに対してひとつインデックスを作成できるようにしました',
            '検索ボタンの配置位置を変更しました',
            '右クリックしたら、ファイルオープン機能、行検索機能などをメニューにでるようにしました',
            '選択したファイルのフォルダーを開く機能を追加しました',
            '検索開始際のメッセージダイアログ機能を再調整しました:A.インデックス作成してから検索 B.そのままインデックス利用して検索 C.操作をキャンセル 上記三つの選択ができるようにしました'
          ]
        },
        {
          time: '2012年8月12日',
          ver: 'V1.2.1',
          update: [
            'ヘルプボタンを追加'
          ]
        },
        {
          time: '2012年8月2日',
          ver: 'V1.2',
          update: [
            '日本語、英語、中国語対応、複数インデックスデータ管理機能を追加'
          ]
        },
        {
          time: '2012年7月30日',
          ver: 'V1.1',
          update: [
            'XP上のList表示の不具合を修正'
          ]
        },
        {
          time: '2012年6月8日',
          ver: 'V1.0',
          update: [
            '初公開'
          ]
        }
      ]
    }
  },
  methods: {
    getTableData () {
      if (this.search === '') {
        this.tableData = this.releaseData
      } else {
        this.tableData = []
        this.releaseData.forEach(item => {
          var bret = item.update.some(subitem => { // some function needs a return clause!
            return subitem.includes(this.search.trim())
          })
          console.log(bret, item.update)
          if (bret) this.tableData.push(item)
        })
      }
      this.pagination.total = this.tableData.length
      var offset = (this.pagination.currentPage - 1) * this.pagination.pageSize
      this.tableData = this.$_.drop(this.tableData, offset).slice(0, this.pagination.pageSize)
      console.log(this.pagination.total)
      console.log(this.pagination.currentPage)
      console.log(this.pagination.pageSize)
    },

    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize
      this.getTableData()
    },

    handleCurrentChange (curPage) {
      this.pagination.currentPage = curPage
      this.getTableData()
    }
  },
  created () {
    this.getTableData()
  }
}
</script>

<style scoped>

.el-table__header {
  width: 100% !important;
  /* width: 850px; */
}

.el-table__body {
  width: 100% !important;
  /* width: 850px; */
}
</style>
